module.exports = __webpack_public_path__ + "media/images/categories/headers/economy-a22a09ea9e790108b0ee51b4671df8d6.jpg";